import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callBannerAuditApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.bannerAudit, payload);
  return data;
};
